import React from "react";
import PolicyPage from "../../components/PolicyPage";
import useCmsData from "../../hook/useCmsData";

const TermsConditions = () => {
  const { cmsData } = useCmsData();
  const policy = cmsData.find((item) => item?.title === "Terms and conditions");

  return <PolicyPage title={policy?.title} content={policy?.content} />;
};

export default TermsConditions;
